import React, { Component } from "react";
import { AppConfig } from "../../../config/config.js";
import { StatsCard } from "../../../components/StatsCard/StatsCard.jsx";
import config from "../../../variables/Constants.jsx";
import withUseApiService from "../../../utils/withUseApiService.jsx";
class DataBaseStat extends Component {
  state = { usage: 0, loading: true, time: null, error: false };

  dataFetch = async () => {
    this.apiService = this.props.apiService;
    this.setState({
      loading: true,
      time: Date(Date.now()),
    });

    this.apiService.getApiInstance()
      .get(
        AppConfig.serviceUrls.dbUsage
      )
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            loading: false,
            error: false,
            time: Date(Date.now()),
            usage: parseFloat(res.data.dbUsage).toFixed(2),
          });
        } else {
          this.setState({
            loading: false,
            error: true,
            time: Date(Date.now()),
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: true,
          time: Date(Date.now()),
        });
      });
  };

  componentDidMount() {
    this.dataFetch();
  }

  render() {
    return (
      <StatsCard
        loading={this.state.loading}
        error={this.state.error}
        bigIcon={<i className="pe-7s-server text-warning" />}
        statsText="Database Usage  "
        statsValue={this.state.usage + "MB"}
        statsIcon={<i className="fa fa-refresh" />}
        statsIconText="date"
      />
    );
  }
}

export default withUseApiService(DataBaseStat);
